// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/admin_crud_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateAdminUserArgs, CreateAdminUserReply, DeleteAdminUserArgs, DeleteAdminUserReply, IndexAdminUserArgs, IndexAdminUserReply, ReadAdminUserArgs, ReadAdminUserReply, UpdateAdminUserArgs, UpdateAdminUserReply } from "./admin_user_crud_service_generated_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { CreateAnnounceArgs, CreateAnnounceReply, DeleteAnnounceArgs, DeleteAnnounceReply, IndexAnnounceArgs, IndexAnnounceReply, ReadAnnounceArgs, ReadAnnounceReply, UpdateAnnounceArgs, UpdateAnnounceReply } from "./announce_crud_service_generated_pb";
import { CreateContactArgs, CreateContactReply, DeleteContactArgs, DeleteContactReply, IndexContactArgs, IndexContactReply, ReadContactArgs, ReadContactReply, UpdateContactArgs, UpdateContactReply } from "./contact_crud_service_generated_pb";
import { CreateContactReadStatusArgs, CreateContactReadStatusReply, DeleteContactReadStatusArgs, DeleteContactReadStatusReply, IndexContactReadStatusArgs, IndexContactReadStatusReply, ReadContactReadStatusArgs, ReadContactReadStatusReply, UpdateContactReadStatusArgs, UpdateContactReadStatusReply } from "./contact_read_status_crud_service_generated_pb";
import { CreateForceReloadArgs, CreateForceReloadReply, DeleteForceReloadArgs, DeleteForceReloadReply, IndexForceReloadArgs, IndexForceReloadReply, ReadForceReloadArgs, ReadForceReloadReply, UpdateForceReloadArgs, UpdateForceReloadReply } from "./force_reload_crud_service_generated_pb";
import { CreateMaintenanceArgs, CreateMaintenanceReply, DeleteMaintenanceArgs, DeleteMaintenanceReply, IndexMaintenanceArgs, IndexMaintenanceReply, ReadMaintenanceArgs, ReadMaintenanceReply, UpdateMaintenanceArgs, UpdateMaintenanceReply } from "./maintenance_crud_service_generated_pb";
import { CreateResultCategoryArgs, CreateResultCategoryReply, DeleteResultCategoryArgs, DeleteResultCategoryReply, IndexResultCategoryArgs, IndexResultCategoryReply, ReadResultCategoryArgs, ReadResultCategoryReply, UpdateResultCategoryArgs, UpdateResultCategoryReply } from "./result_category_crud_service_generated_pb";
import { CreateResultArgs, CreateResultReply, DeleteResultArgs, DeleteResultReply, IndexResultArgs, IndexResultReply, ReadResultArgs, ReadResultReply, UpdateResultArgs, UpdateResultReply } from "./result_crud_service_generated_pb";

/**
 * AdminCRUDServiceサービス定義
 *
 * @generated from service service.AdminCRUDService
 */
export const AdminCRUDService = {
  typeName: "service.AdminCRUDService",
  methods: {
    /**
     * @generated from rpc service.AdminCRUDService.IndexAdminUser
     */
    indexAdminUser: {
      name: "IndexAdminUser",
      I: IndexAdminUserArgs,
      O: IndexAdminUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.CreateAdminUser
     */
    createAdminUser: {
      name: "CreateAdminUser",
      I: CreateAdminUserArgs,
      O: CreateAdminUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.ReadAdminUser
     */
    readAdminUser: {
      name: "ReadAdminUser",
      I: ReadAdminUserArgs,
      O: ReadAdminUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.UpdateAdminUser
     */
    updateAdminUser: {
      name: "UpdateAdminUser",
      I: UpdateAdminUserArgs,
      O: UpdateAdminUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.DeleteAdminUser
     */
    deleteAdminUser: {
      name: "DeleteAdminUser",
      I: DeleteAdminUserArgs,
      O: DeleteAdminUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.IndexAnnounce
     */
    indexAnnounce: {
      name: "IndexAnnounce",
      I: IndexAnnounceArgs,
      O: IndexAnnounceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.CreateAnnounce
     */
    createAnnounce: {
      name: "CreateAnnounce",
      I: CreateAnnounceArgs,
      O: CreateAnnounceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.ReadAnnounce
     */
    readAnnounce: {
      name: "ReadAnnounce",
      I: ReadAnnounceArgs,
      O: ReadAnnounceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.UpdateAnnounce
     */
    updateAnnounce: {
      name: "UpdateAnnounce",
      I: UpdateAnnounceArgs,
      O: UpdateAnnounceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.DeleteAnnounce
     */
    deleteAnnounce: {
      name: "DeleteAnnounce",
      I: DeleteAnnounceArgs,
      O: DeleteAnnounceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.IndexContact
     */
    indexContact: {
      name: "IndexContact",
      I: IndexContactArgs,
      O: IndexContactReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.CreateContact
     */
    createContact: {
      name: "CreateContact",
      I: CreateContactArgs,
      O: CreateContactReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.ReadContact
     */
    readContact: {
      name: "ReadContact",
      I: ReadContactArgs,
      O: ReadContactReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.UpdateContact
     */
    updateContact: {
      name: "UpdateContact",
      I: UpdateContactArgs,
      O: UpdateContactReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.DeleteContact
     */
    deleteContact: {
      name: "DeleteContact",
      I: DeleteContactArgs,
      O: DeleteContactReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.IndexContactReadStatus
     */
    indexContactReadStatus: {
      name: "IndexContactReadStatus",
      I: IndexContactReadStatusArgs,
      O: IndexContactReadStatusReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.CreateContactReadStatus
     */
    createContactReadStatus: {
      name: "CreateContactReadStatus",
      I: CreateContactReadStatusArgs,
      O: CreateContactReadStatusReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.ReadContactReadStatus
     */
    readContactReadStatus: {
      name: "ReadContactReadStatus",
      I: ReadContactReadStatusArgs,
      O: ReadContactReadStatusReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.UpdateContactReadStatus
     */
    updateContactReadStatus: {
      name: "UpdateContactReadStatus",
      I: UpdateContactReadStatusArgs,
      O: UpdateContactReadStatusReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.DeleteContactReadStatus
     */
    deleteContactReadStatus: {
      name: "DeleteContactReadStatus",
      I: DeleteContactReadStatusArgs,
      O: DeleteContactReadStatusReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.IndexForceReload
     */
    indexForceReload: {
      name: "IndexForceReload",
      I: IndexForceReloadArgs,
      O: IndexForceReloadReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.CreateForceReload
     */
    createForceReload: {
      name: "CreateForceReload",
      I: CreateForceReloadArgs,
      O: CreateForceReloadReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.ReadForceReload
     */
    readForceReload: {
      name: "ReadForceReload",
      I: ReadForceReloadArgs,
      O: ReadForceReloadReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.UpdateForceReload
     */
    updateForceReload: {
      name: "UpdateForceReload",
      I: UpdateForceReloadArgs,
      O: UpdateForceReloadReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.DeleteForceReload
     */
    deleteForceReload: {
      name: "DeleteForceReload",
      I: DeleteForceReloadArgs,
      O: DeleteForceReloadReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.IndexMaintenance
     */
    indexMaintenance: {
      name: "IndexMaintenance",
      I: IndexMaintenanceArgs,
      O: IndexMaintenanceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.CreateMaintenance
     */
    createMaintenance: {
      name: "CreateMaintenance",
      I: CreateMaintenanceArgs,
      O: CreateMaintenanceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.ReadMaintenance
     */
    readMaintenance: {
      name: "ReadMaintenance",
      I: ReadMaintenanceArgs,
      O: ReadMaintenanceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.UpdateMaintenance
     */
    updateMaintenance: {
      name: "UpdateMaintenance",
      I: UpdateMaintenanceArgs,
      O: UpdateMaintenanceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.DeleteMaintenance
     */
    deleteMaintenance: {
      name: "DeleteMaintenance",
      I: DeleteMaintenanceArgs,
      O: DeleteMaintenanceReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.IndexResultCategory
     */
    indexResultCategory: {
      name: "IndexResultCategory",
      I: IndexResultCategoryArgs,
      O: IndexResultCategoryReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.CreateResultCategory
     */
    createResultCategory: {
      name: "CreateResultCategory",
      I: CreateResultCategoryArgs,
      O: CreateResultCategoryReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.ReadResultCategory
     */
    readResultCategory: {
      name: "ReadResultCategory",
      I: ReadResultCategoryArgs,
      O: ReadResultCategoryReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.UpdateResultCategory
     */
    updateResultCategory: {
      name: "UpdateResultCategory",
      I: UpdateResultCategoryArgs,
      O: UpdateResultCategoryReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.DeleteResultCategory
     */
    deleteResultCategory: {
      name: "DeleteResultCategory",
      I: DeleteResultCategoryArgs,
      O: DeleteResultCategoryReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.IndexResult
     */
    indexResult: {
      name: "IndexResult",
      I: IndexResultArgs,
      O: IndexResultReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.CreateResult
     */
    createResult: {
      name: "CreateResult",
      I: CreateResultArgs,
      O: CreateResultReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.ReadResult
     */
    readResult: {
      name: "ReadResult",
      I: ReadResultArgs,
      O: ReadResultReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.UpdateResult
     */
    updateResult: {
      name: "UpdateResult",
      I: UpdateResultArgs,
      O: UpdateResultReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminCRUDService.DeleteResult
     */
    deleteResult: {
      name: "DeleteResult",
      I: DeleteResultArgs,
      O: DeleteResultReply,
      kind: MethodKind.Unary,
    },
  }
} as const;

